<template>
  <div class="content-wrapper">
    <section class="content pt-3" v-if="actionPermission === false">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <h3 class="page-title">Group Info</h3>
            <div class="btn-toolbar pull-right">
              <!-- <button class="btn btn-outline" type="button" @click="showFilter = !showFilter">
                <i class="icon-down" :class="showFilter ? 'icon-up' : ''"></i> Filter
              </button> -->
              <router-link
                :to="{ name: 'GroupInfoAdd' }"
                class="btn ml-2"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> Add Group
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col">
                  <div v-if="organizationId == 1" class="form-group">
                    <label class="col-form-label" for="audraname">Audra</label>
                    <div class="input-group">
                      <multiselect
                        v-model="filter.accountId"
                        :options="Object.keys(pre.audraName)"
                        :custom-label="(opt) => pre.audraName[opt]"
                        placeholder="Select Audra"
                        :searchable="true"
                        :multiple="false"
                        id="accountId"
                        v-bind:class="{
                          'has-error': errors.has('accountId'),
                        }"
                        name="accountId"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="form-group">
                    <label class="col-form-label" for="name">Group Name</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fas fa-pencil-alt"></i>
                        </span>
                      </div>
                      <input
                        autocomplete="off"
                        type="text"
                        id="name"
                        name="name"
                        v-model="filter.name"
                        :class="{
                          'has-error': errors.has('name'),
                        }"
                        class="form-control"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="form-group">
                    <label class="col-form-label" for="status">Group Type</label>
                    <div class="input-group">
                      <multiselect
                        v-model="filter.group_type"
                        :options="Object.keys(pre.groupTypeList)"
                        :custom-label="(opt) => pre.groupTypeList[opt]"
                        placeholder="Select Group Type"
                        :searchable="true"
                        :multiple="false"
                        id="group_type"
                        v-bind:class="{
                          'has-error': errors.has('group_type'),
                        }"
                        name="group_type"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 text-right">
                <button type="submit" class="btn mr-3">
                  <i class="icon-search"></i> Search
                </button>
                <button type="reset" class="btn btn-outline" @click="resetFilter()">
                  <i class="icon-refresh"></i> Reset
                </button>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <!-- <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th v-if="organizationId == 1">Audra</th>
                      <th>Group Name</th>
                      <th>Group Type</th>
                      <th>Device(s)</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td v-if="organizationId == 1">
                        {{ val.device_name }}
                      </td>

                      <td>
                        <template v-if="
                          val.name != 'InactiveGroup' &&
                          (val.group_type == '' ||
                            val.group_type == null ||
                            val.group_type == 'DEFAULT')
                        ">
                          <router-link :to="{
                            name: 'addGroupRule',
                            params: {
                              id: val.id,
                              group_name: val.name,
                              accountId: val.accountId
                            }
                          }" class="link-cell">
                            {{ val.name }}
                          </router-link>
                        </template>
                        <template v-else>
                          {{ val.name }}
                        </template>
                      </td>

                      <td>
                        {{
                          val.group_type
                            ? val.group_type == 'DEFAULT'
                              ? 'DEVICE GROUP'
                              : val.group_type + ' GROUP'
                            : 'DEVICE GROUP'
                        }}
                      </td>
                      <td>
                        <router-link class="pc fw-500 d-inline-flex align-items-center text-underline"
                          v-if="val.device_count || val.active_device_count" :to="{
                            name: 'DeviceList',
                            query: {
                              group_name: val.name
                            }
                          }">
                          Devices {{ val.device_count }} of
                          {{ val.active_device_count }} Active
                          <i class="icon-arrow-right-circle ml-1"></i>
                        </router-link>
                      </td>
                      <td class="text-right">
                        <router-link v-if="actionView == true" :to="{
                          name: 'GroupInfoShow',
                          params: { id: val.id }
                        }" class="btn btn-view">
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link v-if="actionEdit == true && val.user_defined == 'YES'" :to="{
                          name: 'GroupInfoEdit',
                          params: { id: val.id }
                        }" class="btn btn-edit">
                          <i class="icon-edit"></i>
                        </router-link>
                        <a v-if="
                          actionDelete == true && val.user_defined == 'YES'
                        " class="btn btn-trash" href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"><i class="icon-trash"></i></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->

              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Name <sort-icons :_sort="'name'" /></th>
                      <th>Device Status</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>
                        <template
                          v-if="
                            val.name != 'InactiveGroup' &&
                            (val.group_type == '' ||
                              val.group_type == null ||
                              val.group_type == 'DEFAULT')
                          "
                        >
                          <router-link
                            :to="{
                              name: 'addGroupRule',
                              params: {
                                id: val.id,
                                group_name: val.name,
                                accountId: val.accountId,
                              },
                            }"
                            class="group-item"
                          >
                            <div class="group-icon">
                              <img :src="`/assets/images/${val.group_img}.svg`" alt="g" />
                            </div>
                            {{ val.name }}
                          </router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: '#' }" class="group-item"
                            ><div class="group-icon">
                              <img :src="`/assets/images/${val.group_img}.svg`" alt="g" />
                            </div>
                            {{ val.name }}</router-link
                          >
                        </template>
                      </td>

                      <td>
                        <span
                          @click="showGroupDevice(val.name, val.group_img, 'ACTIVE')"
                          class="group-device-status mr-2"
                          >Active <b>{{ val.active_device_count }}</b></span
                        >
                        <span
                          @click="showGroupDevice(val.name, val.group_img, 'INACTIVE')"
                          class="group-device-status inactive"
                          >Inactive
                          <b>{{ val.device_count - val.active_device_count }}</b></span
                        >
                      </td>

                      <!-- <td class="text-right">
                        <router-link
                          :to="{
                            name: 'GroupInfoShow',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                      </td> -->

                      <td class="text-right">
                        <router-link
                          v-if="actionView == true"
                          :to="{
                            name: 'GroupInfoShow',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          v-if="actionEdit == true && val.user_defined == 'YES'"
                          :to="{
                            name: 'GroupInfoEdit',
                            params: { id: val.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="actionDelete == true && val.user_defined == 'YES'"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-3 text-right d-block d-sm-none px-3">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>
        </div>
        <div :class="{ 'list-pagination': list.total > list.per_page }">
          <vue-pagination
            :pagination="list"
            v-if="list.total > list.per_page"
            @paginate="reload()"
          ></vue-pagination>
        </div>
      </div>
    </section>

    <!-- <section class="content" v-if="actionPermission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section> -->

    <div
      @click="showDevice = false"
      v-if="showDevice"
      class="modal-backdrop fade show"
    ></div>
    <div class="group-device" :class="showDevice ? 'in' : ''">
      <div class="text-right group-device-close">
        <i @click="showDevice = false" class="icon-close text-secondary"></i>
      </div>
      <div class="current-group">
        <div class="current-group-img">
          <img :src="`/assets/images/${currentGroupIcon}.svg`" alt="g" />
        </div>
        <h3>{{ currentGroup }}</h3>
      </div>
      <div class="tab-nav tab-nav-device mb-3">
        <ul>
          <li :class="{ active: activeTab === 'All' }" @click="activeTab = 'All'">
            All <span>{{ currentGroupDevice.length }}</span>
          </li>
          <li :class="{ active: activeTab === 'ACTIVE' }" @click="activeTab = 'ACTIVE'">
            Active <span>{{ activeDevice }}</span>
          </li>
          <li
            :class="{ active: activeTab === 'INACTIVE' }"
            @click="activeTab = 'INACTIVE'"
          >
            Inactive <span>{{ inactiveDevice }}</span>
          </li>
          <div class="tab-indicator"></div>
        </ul>
      </div>
      <transition name="slide-fade" :key="activeTab">
        <div class="device-list" v-if="activeTab === 'All'">
          <ul>
            <li v-for="(val, index) in currentGroupDevice" :key="val.id">
              <router-link
                :to="{
                  name: 'addDeviceRule',
                  params: {
                    id: val.id,
                    group_name: val.group_name,
                    Device_MAC: val.Device_MAC,
                    accountId: val.accountId,
                    ip_address: val.ip_address,
                  },
                }"
                :class="{
                  connected: val.status === 'ACTIVE',
                  disconnected: val.status === 'INACTIVE',
                }"
              >
                <div class="device-icon">
                  <i class="icon-common-device"></i>
                </div>
                <div class="device-content">
                  <h3>
                    <strong class="text-truncate mr-1">{{ val.Name }}</strong>
                  </h3>
                  <p>{{ val.Device_MAC }}</p>
                </div>
              </router-link>

              <div
                class="d-flex ml-auto"
                v-if="val.blocked == 0"
                href="javascript:void(0)"
                @click="
                  deviceBlockUnblock(
                    val.id,
                    val.accountId,
                    val.Device_MAC,
                    val.status,
                    val.blocked
                  )
                "
              >
                <div
                  data-toggle="tooltip"
                  data-placement="left"
                  title="Turn off internet"
                  class="internet-switch active ml-auto"
                >
                  ON <i class="icon-globe"></i>
                </div>
              </div>
              <div
                class="d-flex ml-auto"
                v-else
                href="javascript:void(0)"
                @click="
                  deviceBlockUnblock(
                    val.id,
                    val.accountId,
                    val.Device_MAC,
                    val.status,
                    val.blocked
                  )
                "
              >
                <div title="Turn on internet" class="internet-switch ml-auto">
                  <i class="icon-globe"></i> OFF
                </div>
              </div>
            </li>
          </ul>
          <div class="no-data" v-if="currentGroupDevice.length == 0">
            <img src="/assets/images/no-data.svg" alt="" />
            <h3>No Device Found!</h3>
          </div>
        </div>
      </transition>
      <transition name="slide-fade" :key="activeTab">
        <div class="device-list" v-if="activeTab === 'ACTIVE'">
          <ul>
            <li
              v-for="(val, index) in currentGroupDevice"
              :key="val.id"
              v-if="val.status === 'ACTIVE'"
            >
              <router-link
                :to="{
                  name: 'addDeviceRule',
                  params: {
                    id: val.id,
                    group_name: val.group_name,
                    Device_MAC: val.Device_MAC,
                    accountId: val.accountId,
                    ip_address: val.ip_address,
                  },
                }"
                :class="{ connected: val.status === 'ACTIVE' }"
              >
                <div class="device-icon">
                  <i class="icon-common-device"></i>
                </div>
                <div class="device-content">
                  <h3>
                    <strong class="text-truncate mr-1">{{ val.Name }}</strong>
                  </h3>
                  <p>{{ val.Device_MAC }}</p>
                </div>
              </router-link>
              <div
                class="d-flex ml-auto"
                v-if="val.blocked == 0"
                href="javascript:void(0)"
                @click="
                  deviceBlockUnblock(
                    val.id,
                    val.accountId,
                    val.Device_MAC,
                    val.status,
                    val.blocked
                  )
                "
              >
                <div
                  data-toggle="tooltip"
                  data-placement="left"
                  title="Turn off internet"
                  class="internet-switch active ml-auto"
                >
                  ON <i class="icon-globe"></i>
                </div>
              </div>
              <div
                class="d-flex ml-auto"
                v-else
                href="javascript:void(0)"
                @click="
                  deviceBlockUnblock(
                    val.id,
                    val.accountId,
                    val.Device_MAC,
                    val.status,
                    val.blocked
                  )
                "
              >
                <div title="Turn on internet" class="internet-switch ml-auto">
                  <i class="icon-globe"></i> OFF
                </div>
              </div>
            </li>
          </ul>
          <div class="no-data" v-if="activeDevice == 0">
            <img src="/assets/images/no-data.svg" alt="" />
            <h3>No active device found!</h3>
          </div>
        </div>
      </transition>
      <transition name="slide-fade" :key="activeTab">
        <div class="device-list" v-if="activeTab === 'INACTIVE'">
          <ul>
            <li
              v-for="(val, index) in currentGroupDevice"
              :key="val.id"
              v-if="val.status === 'INACTIVE'"
            >
              <router-link
                :to="{
                  name: 'addDeviceRule',
                  params: {
                    id: val.id,
                    group_name: val.group_name,
                    Device_MAC: val.Device_MAC,
                    accountId: val.accountId,
                    ip_address: val.ip_address,
                  },
                }"
                :class="{ disconnected: val.status === 'INACTIVE' }"
              >
                <div class="device-icon">
                  <i class="icon-common-device"></i>
                </div>
                <div class="device-content">
                  <h3>
                    <strong class="text-truncate mr-1">{{ val.Name }}</strong>
                  </h3>
                  <p>{{ val.Device_MAC }}</p>
                </div>
              </router-link>
              <div
                class="d-flex ml-auto"
                v-if="val.blocked == 0"
                href="javascript:void(0)"
                @click="
                  deviceBlockUnblock(
                    val.id,
                    val.accountId,
                    val.Device_MAC,
                    val.status,
                    val.blocked
                  )
                "
              >
                <div
                  data-toggle="tooltip"
                  data-placement="left"
                  title="Turn off internet"
                  class="internet-switch active ml-auto"
                >
                  ON <i class="icon-globe"></i>
                </div>
              </div>
              <div
                class="d-flex ml-auto"
                v-else
                href="javascript:void(0)"
                @click="
                  deviceBlockUnblock(
                    val.id,
                    val.accountId,
                    val.Device_MAC,
                    val.status,
                    val.blocked
                  )
                "
              >
                <div title="Turn on internet" class="internet-switch ml-auto">
                  <i class="icon-globe"></i> OFF
                </div>
              </div>
            </li>
          </ul>
          <div class="no-data" v-if="inactiveDevice == 0">
            <img src="/assets/images/no-data.svg" alt="" />
            <h3>No inactive device found!</h3>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions, mapGetters } from "vuex";
const fileDownload = require("js-file-download");

export default {
  name: "GroupInfo",
  metaInfo: {
    title: "Group Info | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: false,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: {},
      groupTypeList: {
        DEFAULT: "DEVICE GROUP",
        IP: "IP GROUP",
        DOMAIN: "DOMAIN GROUP",
        PORT: "PORT GROUP",
      },
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: false,
    actionPermission: false,
    selected_row: [],
    is_selected_all: false,
    showDevice: false,
    activeTab: "ACTIVE",
    devices: [],
    currentGroup: "Guest",
    currentGroupIcon: null,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }

    if (this.profile.hasOwnProperty("name")) {
      // this.setPermissions("group_info");
    }

    this.api_url = "/group_info";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
    currentGroupDevice() {
      if (!this.devices || !this.devices.data) {
        return [];
      }
      return this.devices.data.filter((device) => device.group_name == this.currentGroup);
    },
    activeDevice() {
      return this.currentGroupDevice.filter((device) => device.status === "ACTIVE")
        .length;
    },
    inactiveDevice() {
      return this.currentGroupDevice.filter((device) => device.status === "INACTIVE")
        .length;
    },
  },
  watch: {
    profile: function (newUser, oldUser) {
      if (!_.isEmpty(newUser)) {
        // this.setPermissions("group_info");
      }
    },
  },

  methods: {
    ...mapActions(["FETCH_PROFILE"]),

    showGroupDevice(groupName, groupIcon, activeTab) {
      this.currentGroupIcon = groupIcon;
      this.currentGroup = groupName;
      this.showDevice = true;
      this.activeTab = activeTab;
    },

    async initialize() {
      this.is_loading = true;
      try {
        const response = await this.getList();
        this.list = response.data;

        const audraResponse = await CommonAPI.getAudraName(LocalStorage.get("accountId"));
        this.pre.audraName = audraResponse;

        await this.getDevices();
      } catch (error) {
        this.empty = true;
        if (error.response?.status === 403) {
          this.has_permission = false;
        }
      } finally {
        this.is_loading = false;
      }
    },

    async getDevices() {
      try {
        const { data } = await axios.get("/get-group-devices", {
          params: { userAccountId: LocalStorage.get("accountId") },
        });
        this.devices = data;
        return data;
      } catch (error) {
        console.error("Error fetching devices:", error);
        throw error;
      }
    },

    async getFilterData() {
      this.is_loading = true;
      try {
        const response = await this.getList();
        this.list = response.data;
      } catch (error) {
        this.empty = true;
        if (error.response?.status === 403) {
          this.has_permission = false;
        }
      } finally {
        this.is_loading = false;
      }
    },

    async reload() {
      try {
        const response = await this.getList();
        this.list = response.data;
      } catch (error) {
        this.empty = true;
        if (error.response?.status === 403) {
          this.has_permission = false;
        }
      }
    },

    getList() {
      const params = {
        ...this.filter,
        userAccountId: LocalStorage.get("accountId"),
        ...this.$route.query,
        page: this.list.current_page,
      };
      return axios.get(this.api_url, { params });
    },

    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      await this.getFilterData();
    },

    async deleteObject(id, accountId, index) {
      const delete_api_url = `/group_info/${id}`;
      const result = await this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (!result.isConfirmed) return;

      this.is_loading = true;
      try {
        const response = await axios.delete(delete_api_url, { params: { accountId } });
        this.list.data.splice(index, 1);
        this.$toaster.success(response.data.message);
      } catch (errors) {
        if (errors.response?.status === 501) {
          this.$toaster.error(errors.response.data.errors.message);
          this.$setErrorsFromResponse(errors.response.data.errors);
        } else if (errors.response?.data) {
          this.$toaster.error(errors.response.data.message);
          this.$setErrorsFromResponse(errors.response.data);
        }
      } finally {
        this.is_loading = false;
      }
    },

    async deviceBlockUnblock(id, accountId, Device_MAC, status, blocked) {
      const newBlockedValue = blocked == 1 ? 0 : 1;
      this.is_loading = true;
      try {
        const { data } = await axios.post("/deviceBlockUnblock", {
          id,
          accountId,
          Device_MAC,
          status,
          action: newBlockedValue,
        });
        this.$toaster.success(data.message);

        // Update local devices state
        const deviceIndex = this.devices.data.findIndex((d) => d.id === id);
        if (deviceIndex !== -1) {
          this.$set(this.devices.data, deviceIndex, {
            ...this.devices.data[deviceIndex],
            blocked: newBlockedValue,
          });
        }
      } catch (errors) {
        if (errors.response?.status === 501) {
          this.$toaster.error(errors.response.data.errors.message);
          this.$setErrorsFromResponse(errors.response.data.errors);
        } else if (errors.response?.data) {
          this.$toaster.error(errors.response.data.message);
          this.$setErrorsFromResponse(errors.response.data);
        }
      } finally {
        this.is_loading = false;
      }
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
<style>
.page-title {
  font-size: 24px;
  margin: 0;
  font-weight: 600;
}
.table > thead > tr > th {
  background-color: #fafafa !important;
  border: none !important;
  color: #1e1e1e !important;
}
.table > thead > tr > th:first-child {
  border-radius: 8px 0 0 8px;
}
.table > thead > tr > th:last-child {
  border-radius: 0 8px 8px 0;
}
.table td,
.table th {
  border-top: none !important;
}

.group-device-status b {
  white-space: nowrap;
}
</style>
